
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/apply",
      function () {
        return require("private-next-pages/en/apply/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/apply"])
      });
    }
  